import { render } from "./SpotifyCallback.vue?vue&type=template&id=6f90c494"
import script from "./SpotifyCallback.vue?vue&type=script&lang=js"
export * from "./SpotifyCallback.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__